import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {AdministrationComponent} from './view-layer/components/administration.component';
import {UserDialogComponent} from './view-layer/components/add_user.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {SourcesComponent} from './view-layer/components/sources.component';
import {LoginComponent} from './view-layer/components/login.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSnackBarModule} from "@angular/material/snack-bar";
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TextFieldModule } from '@angular/cdk/text-field';
import { AgGridAngular } from 'ag-grid-angular';
import { ContentComponent } from './view-layer/components/content_db.component';
import { ErrorInterceptor } from './error.interceptor';
import { LoadingComponent } from './view-layer/components/loading.component';
import { LoadingService } from './data-access-layer/services/loading.service';
import { ChatComponent } from './view-layer/components/chat.component';
import { LoadingChatComponent } from './view-layer/components/loading_chat.component';
import { LoadingUpdatingComponent } from './view-layer/components/loading_updating.component';
import { AppConfigService } from './app-config.service';
import { TranslocoModule, TRANSLOCO_CONFIG, translocoConfig, TRANSLOCO_LOADER } from '@ngneat/transloco';
import { TranslocoRootModule } from './transloco.loader';
import { LanguageSelectorComponent } from './view-layer/components/language-selector.component';
import { SourceDialogComponent } from './view-layer/components/source-settings.component';
import { InlineLoadingComponent } from './view-layer/components/inline-loading.component';
import { FlatpickrModule } from 'angularx-flatpickr';
import { LineageComponent } from './view-layer/components/lineage.component';
import { GalleriaModule } from 'primeng/galleria';
import { ChangesSourcesComponent } from './view-layer/components/changes-sources.component';
import { BlurOnEnterDirective } from './shared/directives/blur-on-enter.directive';
import { CloseOnEscapeDirective } from './shared/directives/close-on-escape.directive';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PromptUpdateService } from './data-access-layer/services/prompt-update.service';
import { AlertDialogComponent } from './view-layer/components/alert-dialog.component';
import { GlossaryComponent } from './view-layer/components/glossary.component';

export function loadAppConfig(appConfig: AppConfigService) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AdministrationComponent,
    SourcesComponent,
    LoginComponent,
    ContentComponent,
    UserDialogComponent,
    SourceDialogComponent,
    LineageComponent,
    ChangesSourcesComponent,
    GlossaryComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSnackBarModule,
    TextFieldModule,
    AgGridAngular,
    LoadingComponent,
    LoadingChatComponent,
    InlineLoadingComponent,
    LoadingUpdatingComponent,
    FlatpickrModule.forRoot(),
    NgCircleProgressModule.forRoot({
      "backgroundStrokeWidth": 0,
      "backgroundPadding": -10,
      "radius": 38,
      "space": 17,
      "maxPercent": 100,
      "unitsFontSize": "27",
      "unitsColor": "#bdbdbd",
      "outerStrokeWidth": 8,
      "outerStrokeColor": "#bababa",
      "outerStrokeLinecap": "inherit",
      "innerStrokeWidth": 18,
      "titleColor": "#bababa",
      "titleFontSize": "28",
      "titleFontWeight": "700",
      "animationDuration": 200,
      "showSubtitle": false,
      "showBackground": false,
      "showInnerStroke": false
    }),
    TranslocoRootModule,
    TranslocoModule,
    GalleriaModule,
    BlurOnEnterDirective,
    CloseOnEscapeDirective,
    AlertDialogComponent,
    ChatComponent,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: loadAppConfig, deps: [AppConfigService], multi: true }
  ],
  bootstrap: [SourcesComponent]
})
export class AppModule {
  constructor(private promptUpdateService: PromptUpdateService) { }
}
